import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'assetUtilizzo',
})
export class AssetUtilizzoPipe implements PipeTransform {
  transform(value: { purpose: number; lost?: boolean; faulty?: boolean }): string {
    const label = value.purpose === 1 ? 'Vendita' : 'Manutenzione';
    const flags = [value.lost && 'Perso', value.faulty && 'Guasto'].filter(Boolean);
    return flags.length > 0 ? `${label} (${flags.join(', ')})` : label;
  }
}
